export default __webpack_public_path__ + "assets/images/3.20ad92.png";